export var rewardIds = [
    "currentptsbalance",
    "pointstogo",
    "rewardsthreshold",
];
